<!--header-->
<div class="tw-flex tw-items-center tw-mb-3 tw-gap-2">
  <icon
    [name]="'receipt'"
    [size]="5"
    [currentColor]="'dt-custom-teal-11'"
    class="tw-p-2.5 tw-rounded-full tw-bg-tealgray-100"
  ></icon>
  <span
    class="tw-text-lg tw-leading-snug tw-text-dt-text-headings tw-font-medium tw-w-full tw-block tw-mt-2"
    >{{ rowData().description }}</span
  >
</div>

<app-tabs-wrapper [(tabActive)]="tabActive">
  <app-add-edit-transaction-form
    [isEditExistingTransaction]="isEditTransaction"
    [transactionToEdit]="transactionToEdit"
    [selectedDateRange]="selectedDateRange"
    [tabActive]="tabActive()"
    [selectedAccount]="rowData().accountView"
    [currency]="
      $any(rowData().transactionView.quantity?.currency) || rowData().accountView?.currency
    "
    (symbolAndCurrencyEqualChange)="onSymbolAndCurrencyEqualChange($event)"
  >
  </app-add-edit-transaction-form>
</app-tabs-wrapper>

<div
  class="tw-text-base tw-flex tw-justify-end sm:tw-block tw-items-center tw-mt-10"
  [attr.aria-busy]="submitting || null"
>
  <app-gloss-button
    class="tw-flex tw-w-1/2 sm:tw-block sm:tw-w-full"
    [fontClass]="'tw-font-medium'"
    [options]="saveButton"
  ></app-gloss-button>
</div>
